import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ReactiveFormsModule } from '@angular/forms';
import { IconsComponent } from '../actions/@base/components/icons/icons.component';
import { AutoFocusDirective } from '../actions/@base/directives/auto-focus.directive';
import { ClickOutsideDirective } from './directives/click-outside.directive';
import { UtilitiesService } from '../actions/@base/services';
import { FixRenderDirective } from '../actions/@base/directives/fix-render.directive';
import { BackToTextbookDirective } from './directives/back-to-textbook.directive';

const entities = [
  IconsComponent,
  AutoFocusDirective,
  ClickOutsideDirective,
  FixRenderDirective,
  BackToTextbookDirective,
];

@NgModule({
  declarations: entities,
  exports: entities,
  imports: [CommonModule, DragDropModule, ReactiveFormsModule],
  providers: [UtilitiesService],
})
export class CommonUtilityModule {}
